import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminRole } from '../hooks/useAdminRole';

const ROLE2_ALLOWED_PATHS = ['/admin/depense', '/admin/reservations'];

export const AdminRouteGuard = ({ children }) => {
  const { role } = useAdminRole();
  const location = useLocation();
  const pathname = location.pathname;

  if (role === null) {
    return children;
  }

  if (role === 2) {
    if (pathname === '/admin' || pathname === '/admin/') {
      return <Navigate to="/admin/depense" replace />;
    }
    if (!ROLE2_ALLOWED_PATHS.includes(pathname)) {
      return <Navigate to="/admin/depense" replace />;
    }
  }

  return children;
};

